module.exports = __webpack_public_path__ + "static/media/onda-violeta-2.a399751e.png";